import { useMutation } from '@tanstack/react-query';

import {
  transferConsultantCandidateData,
  TransferConsultantCandidateDataRequest,
  TransferConsultantCandidateDataResponse,
} from '@/actions/consultant/transferConsultantCandidateData';
import { ApiResponse } from '@/types/response.type';

export interface UseTransferConsultantCandidateDataReturn {
  mutate: (payload: TransferConsultantCandidateDataRequest) => void;
  result: ApiResponse<TransferConsultantCandidateDataResponse> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useTransferConsultantCandidateData =
  (): UseTransferConsultantCandidateDataReturn => {
    const mutation = useMutation({
      mutationFn: transferConsultantCandidateData,
    });

    return {
      mutate: mutation.mutate,
      result: mutation.data,
      error: mutation.error,
      isError: mutation.isError,
      isLoading: mutation.isPending,
      isSuccess: mutation.isSuccess,
    };
  };
